import { createContext, useContext, useState, useEffect, useRef, useCallback } from "react";

const RefreshContext = createContext(null);

// Auto-Refresh Intervall (ms). Bei Bedarf hier anpassen.
export const REFRESH_INTERVAL_MS = 600000;

export function RefreshProvider({ children }) {
  const [tick, setTick] = useState(0);
  const [lastRefresh, setLastRefresh] = useState(Date.now());

  const refreshNow = useCallback(() => {
    setTick((t) => t + 1);
    setLastRefresh(Date.now());
  }, []);

  useEffect(() => {
    const id = setInterval(() => {
      setTick((t) => t + 1);
      setLastRefresh(Date.now());
    }, REFRESH_INTERVAL_MS);
    return () => clearInterval(id);
  }, []);

  return (
    <RefreshContext.Provider value={{ tick, lastRefresh, refreshNow }}>
      {children}
    </RefreshContext.Provider>
  );
}

export const useRefresh = () => useContext(RefreshContext);

// Ruft fn() bei jedem Refresh-Tick auf (Auto-Intervall oder manueller Knopf),
// überspringt aber den ersten Render (Seiten laden bereits beim Mount).
export function useRefreshEffect(fn) {
  const ctx = useContext(RefreshContext);
  const tick = ctx?.tick ?? 0;
  const first = useRef(true);
  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    fn();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tick]);
}
